  function findDomMarkerElement(mapResult, mapContainer) {
    const container = mapContainer;
    if (!container) {
      return null;
    }

    if (mapResult.id) {
      const byId = container.querySelector(
        `[data-marker-icon][data-id="${CSS.escape(String(mapResult.id))}"]`,
      );
      if (byId) {
        return byId;
      }
    }

    if (mapResult.communityId) {
      return container.querySelector(
        `[data-marker-icon][data-community-id="${CSS.escape(String(mapResult.communityId))}"]`,
      ) ?? null;
    }

    return null;
  }

  export default findDomMarkerElement;